import Public from 'layouts/Public/Public.jsx'
import Dashboard from 'layouts/Dashboard/Dashboard.jsx'

var indexRoutes = [
  { path: '/public', name: 'Public', component: Public },
  { path: '/', name: 'Home', component: Dashboard }
]

export default indexRoutes
